import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "col-xxl-12" }
const _hoisted_2 = { class: "card-header border-0 pt-5" }
const _hoisted_3 = { class: "card-title align-items-center" }
const _hoisted_4 = { class: "svg-icon svg-icon-2 me-2 text-primary" }
const _hoisted_5 = /*#__PURE__*/_createVNode("span", { class: "card-label fw-bold fs-3" }, "Retail Sales", -1)
const _hoisted_6 = { class: "card-body py-3" }
const _hoisted_7 = { class: "table-responsive" }
const _hoisted_8 = { class: "table align-middle gs-0 gy-4" }
const _hoisted_9 = /*#__PURE__*/_createVNode("thead", null, [
  /*#__PURE__*/_createVNode("tr", { class: "text-muted fw-semibold fs-8 text-uppercase" }, [
    /*#__PURE__*/_createVNode("th", { class: "ps-4" }, "Ref. #"),
    /*#__PURE__*/_createVNode("th", null, "Customer Name"),
    /*#__PURE__*/_createVNode("th", null, "Date"),
    /*#__PURE__*/_createVNode("th", null, "Product Name"),
    /*#__PURE__*/_createVNode("th", null, "Quantity"),
    /*#__PURE__*/_createVNode("th", { class: "text-end pe-4" }, "Income")
  ])
], -1)
const _hoisted_10 = { key: 0 }
const _hoisted_11 = /*#__PURE__*/_createVNode("td", {
  colspan: "6",
  class: "text-center text-muted py-10"
}, "No retail sales found.", -1)
const _hoisted_12 = { class: "ps-4" }
const _hoisted_13 = { class: "text-muted fs-8" }
const _hoisted_14 = { class: "d-flex align-items-center" }
const _hoisted_15 = { class: "seq-row-icon seq-row-icon--blue me-3" }
const _hoisted_16 = { class: "svg-icon svg-icon-3 svg-icon-white" }
const _hoisted_17 = { class: "fw-semibold text-gray-800" }
const _hoisted_18 = { class: "text-muted fs-8" }
const _hoisted_19 = { class: "fw-semibold text-gray-800" }
const _hoisted_20 = { class: "fw-semibold text-gray-800" }
const _hoisted_21 = { class: "text-end pe-4" }
const _hoisted_22 = { class: "fw-semibold seq-trend-up" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_skeleton = _resolveComponent("el-skeleton")
  const _component_inline_svg = _resolveComponent("inline-svg")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _withDirectives(_createVNode("div", null, [
      _createVNode(_component_el_skeleton, {
        rows: 10,
        animated: ""
      })
    ], 512), [
      [_vShow, _ctx.loading]
    ]),
    _withDirectives(_createVNode("div", _hoisted_1, [
      _createVNode("div", {
        class: [_ctx.widgetClasses, "card seq-card"]
      }, [
        _createVNode("div", _hoisted_2, [
          _createVNode("h3", _hoisted_3, [
            _createVNode("span", _hoisted_4, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotone/Shopping/Chart-line1.svg" })
            ]),
            _hoisted_5
          ])
        ]),
        _createVNode("div", _hoisted_6, [
          _createVNode("div", _hoisted_7, [
            _createVNode("table", _hoisted_8, [
              _hoisted_9,
              _createVNode("tbody", null, [
                (_ctx.list.length === 0)
                  ? (_openBlock(), _createBlock("tr", _hoisted_10, [
                      _hoisted_11
                    ]))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.list, (item, index) => {
                  return (_openBlock(), _createBlock("tr", { key: index }, [
                    _createVNode("td", _hoisted_12, [
                      _createVNode("span", _hoisted_13, _toDisplayString(item.id), 1)
                    ]),
                    _createVNode("td", null, [
                      _createVNode("div", _hoisted_14, [
                        _createVNode("span", _hoisted_15, [
                          _createVNode("span", _hoisted_16, [
                            _createVNode(_component_inline_svg, { src: "media/icons/duotone/General/User.svg" })
                          ])
                        ]),
                        _createVNode("div", _hoisted_17, _toDisplayString(item.custname), 1)
                      ])
                    ]),
                    _createVNode("td", null, [
                      _createVNode("div", _hoisted_18, _toDisplayString(item.terminal_date), 1)
                    ]),
                    _createVNode("td", null, [
                      _createVNode("div", _hoisted_19, _toDisplayString(item.prodname), 1)
                    ]),
                    _createVNode("td", null, [
                      _createVNode("div", _hoisted_20, _toDisplayString(item.qty), 1)
                    ]),
                    _createVNode("td", _hoisted_21, [
                      _createVNode("div", _hoisted_22, _toDisplayString(_ctx.numberWithCommas(item.income)), 1)
                    ])
                  ]))
                }), 128))
              ])
            ])
          ])
        ])
      ], 2)
    ], 512), [
      [_vShow, !_ctx.loading]
    ])
  ], 64))
}